import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { CustomerQuery } from './CustomerQuery';
import { PolicyQuery } from './PolicyQuery';

@supertypeClass({ toClient: true, toServer: true })
export class ApplicationQuery extends Everything {
  @property()
  customer: CustomerQuery;

  // Copied from ApplicationCore
  @property({ type: Array, getType: () => PolicyQuery })
  policies: Array<PolicyQuery>;

  @property({ sensitiveData: true })
  applicationNumber: string;

  @property()
  type: string;

  @property()
  createdTime: Date;

  constructor() {
    super();
  }

  static new() {
    return new ApplicationQuery().init();
  }

  init() {
    return this;
  }

  get primaryPolicy() {
    return (this.policies || []).reduce((priPol, pol) => {
      return priPol || (pol.isPrimary ? pol : null);
    }, null);
  }

  // END Copied from ApplicationCore
}
